import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-01751040"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0,
  class: "lecture-wrapper"
};
const _hoisted_2 = {
  class: "lecture-container"
};
const _hoisted_3 = {
  class: "link-list"
};
const _hoisted_4 = {
  class: "text"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "btn-text"
}, "更多", -1));

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont icon-chakanquanbu"
}, null, -1));

import CardHeader from '@/pages/components/CardHeader.vue';
import LectureCard from './LectureCard.vue';
export default {
  props: {
    menu: Object
  },

  setup(__props) {
    const props = __props;
    const $http = inject('$http');
    const lectureList = ref([]);

    const getLectureList = async () => {
      const res = await $http.getHomeTranings({
        start_time_sort: 1,
        menu_id: props.menu.menu_id,
        live_status: 5
      });
      console.log('培训研讨', res);
      lectureList.value = res.content || [];
    };

    getLectureList();
    return (_ctx, _cache) => {
      return lectureList.value && lectureList.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(CardHeader, {
        bodyStyle: {
          background: 'transparent'
        },
        link: `/lectureList.html?name=${__props.menu.module_name}&menuId=${__props.menu.menu_id}`
      }, {
        left: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", _hoisted_4, _toDisplayString(__props.menu.module_name), 1)])]),
        right: _withCtx(() => [_hoisted_5, _hoisted_6]),
        _: 1
      }, 8, ["link"]), _createElementVNode("div", {
        class: _normalizeClass(["lecture-content", {
          'one-lecture-content': lectureList.value.length == 1
        }])
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lectureList.value.slice(0, 2), (item, index) => {
        return _openBlock(), _createBlock(LectureCard, {
          key: index,
          lectureCount: lectureList.value.length,
          lectureData: item,
          menu: __props.menu
        }, null, 8, ["lectureCount", "lectureData", "menu"]);
      }), 128))], 2)])])) : _createCommentVNode("", true);
    };
  }

};